<div class="av-card p-3 d-flex flex-column gap-3" data-testid="dunning-panel">
  <h3 class="av-section-title m-0">{{ 'backoffice.billing.attention.title' | translate }}</h3>

  @if (facade.attention(); as attention) {
    <div class="d-flex flex-wrap gap-4">
      <div class="d-flex flex-column gap-1">
        <span class="av-meta">{{ 'backoffice.billing.attention.open_invoices' | translate }}</span>
        <span class="cell-strong" data-testid="attention-open-invoices">
          {{ attention.open_invoice_count }}
        </span>
      </div>

      <div class="d-flex flex-column gap-1">
        <span class="av-meta">{{ 'backoffice.billing.attention.failed_payments' | translate }}</span>
        <span class="cell-strong" data-testid="attention-failed-payments">
          {{ attention.failed_payment_count }}
        </span>
      </div>

      <div class="d-flex flex-column gap-1">
        <span class="av-meta">{{ 'backoffice.billing.attention.state' | translate }}</span>
        <av-status-chip
          [label]="
            (attention.in_dunning
              ? 'backoffice.billing.attention.needs_attention'
              : 'backoffice.billing.attention.state_clear'
            ) | translate
          "
          [tone]="attention.in_dunning ? 'warning' : 'positive'"
        ></av-status-chip>
      </div>
    </div>

    <p class="av-meta m-0" data-testid="attention-summary">
      {{
        (attention.in_dunning
          ? 'backoffice.billing.attention.in_dunning'
          : 'backoffice.billing.attention.clear'
        ) | translate
      }}
    </p>

    <div class="d-flex flex-column gap-2" data-testid="dunning-ladder">
      <h4 class="av-section-title m-0">{{ 'backoffice.billing.dunning.title' | translate }}</h4>

      @if (dunning(); as ladder) {
        @if (hasLadder()) {
          <div class="d-flex flex-wrap gap-4">
            <div class="d-flex flex-column gap-1">
              <span class="av-meta">{{ 'backoffice.billing.dunning.invoice_count' | translate }}</span>
              <span class="cell-strong">{{ ladder.invoice_count }}</span>
            </div>

            <div class="d-flex flex-column gap-1">
              <span class="av-meta">{{ 'backoffice.billing.dunning.first_failure' | translate }}</span>
              <span class="cell-strong" data-testid="dunning-first-failed">
                {{
                  ladder.first_failed_at
                    ? (ladder.first_failed_at | date: dateTimeFormat)
                    : unresolved
                }}
              </span>
            </div>

            <div class="d-flex flex-column gap-1">
              <span class="av-meta">{{ 'backoffice.billing.dunning.elapsed_days' | translate }}</span>
              <span class="cell-strong">{{ ladder.elapsed_days ?? unresolved }}</span>
            </div>

            <div class="d-flex flex-column gap-1">
              <span class="av-meta">{{ 'backoffice.billing.dunning.rungs' | translate }}</span>
              <span class="cell-strong" data-testid="dunning-rungs">
                {{ ladder.rungs.join(', ') }}
              </span>
            </div>

            <div class="d-flex flex-column gap-1">
              <span class="av-meta">{{ 'backoffice.billing.dunning.last_rung' | translate }}</span>
              <span class="cell-strong">{{ ladder.last_rung ?? unresolved }}</span>
            </div>

            <div class="d-flex flex-column gap-1">
              <span class="av-meta">{{ 'backoffice.billing.dunning.next_rung' | translate }}</span>
              <span class="cell-strong" data-testid="dunning-next-rung">
                {{ ladder.next_rung ?? unresolved }}
              </span>
            </div>
          </div>

          @if (ladder.is_terminal) {
            <div class="av-banner p-3 d-flex align-items-start gap-2" data-testid="dunning-terminal">
              <mat-icon aria-hidden="true">block</mat-icon>
              <span>{{ 'backoffice.billing.dunning.terminal' | translate }}</span>
            </div>
          }
        } @else {
          <p class="av-meta m-0" data-testid="dunning-not-started">{{ 'backoffice.billing.dunning.not_started' | translate }}</p>
        }
      } @else {
        <p class="av-meta m-0">{{ 'backoffice.billing.dunning.not_started' | translate }}</p>
      }

      <p class="av-meta m-0">{{ 'backoffice.billing.dunning.note' | translate }}</p>
    </div>
  } @else if (facade.attentionState() === 'error') {
    <div class="av-banner p-3 d-flex align-items-start gap-2" data-testid="attention-error">
      <mat-icon aria-hidden="true">error_outline</mat-icon>
      <span>{{ 'backoffice.billing.attention.error' | translate }}</span>
    </div>
  } @else {
    <p class="av-meta m-0" data-testid="attention-loading">
      {{ 'backoffice.billing.attention.loading' | translate }}
    </p>
  }
</div>
